import {
  patchState,
  signalStore,
  withComputed,
  withMethods,
  withState,
} from "@ngrx/signals";
import { ArticleLine } from "../models/articleline";
import { Cart } from "../models/cart";
import { computed, inject } from "@angular/core";
import { ProductService } from "../services/product.service";
import { firstValueFrom } from "rxjs";

const initialCart: Cart = {
  articles: [],
};

export const CartStore = signalStore(
  { providedIn: "root" },
  withState(initialCart),
  withMethods((store) => {
    function addArticle(article: ArticleLine): void {
      const exists = store.articles().find((a) => {
        const sameProductId =  (a.product.id === article.product.id);

        if (!sameProductId) {
          return false;
        }

        for (const questionId in article.questionDetails) {
          const questionDetail = article.questionDetails[questionId];
          if (questionDetail.answerId !== a.questionDetails[questionId].answerId) {
            return false;
          }
        }
        return true;
      });

      if (exists) {
        incrementArticle(exists.generatedId);
      } else {
        patchState(store, {
          articles: [article, ...store.articles()],
        });
      }
    }
    function incrementArticle(id: string): void {
      const array = store.articles().map((a) => {
        if (a.generatedId === id) a.quantity++;

        return a;
      });
      patchState(store, {
        articles: array,
      });
    }
    function decrementArticleByGeneratedId(id: string): void {
      const array = store.articles().map((a) => {
        if (a.generatedId === id) a.quantity--;
        return a;
      }).filter((a) => {
        return a.quantity > 0;
      });
      patchState(store, {
        articles: array,
      });
    }
    function decrementArticleByProductId(id: string): void {
      const firstFound = store.articles().find((a) => {
        return a.product.id === id;
      })
      const array = store.articles().map((a) => {
        if (a.generatedId === firstFound.generatedId) a.quantity--;
        return a;
      }).filter((a) => {
        return a.quantity > 0;
      });
      patchState(store, {
        articles: array,
      });
    }
    return { addArticle, incrementArticle, decrementArticleByGeneratedId, decrementArticleByProductId };
  }),
  withComputed((store, productsService = inject(ProductService)) => ({
    totalPrice: computed(async () => {
      let totalPrice= 0;
      for (const currentArticle of store.articles()) {
        const quantity = currentArticle.quantity;
        const product = productsService.getProductById(
          currentArticle.product.id,
          await firstValueFrom(productsService.getAllCategoriesAndProducts())
        );
         let price = +product.price * quantity;

        for (const currentOptionId in currentArticle.questionDetails) {
          const currentOption = currentArticle.questionDetails[currentOptionId];
          price += +currentOption.price * quantity;
        }
        totalPrice += price
      }
      return totalPrice
    }),
  }))
);
